import React, {forwardRef, ReactNode, useImperativeHandle, useState} from 'react';
import './Checkbox.less';
import IconButton from "./IconButton/IconButton";
import Icons from "./IconButton/Icons";

export type CheckboxWithStateHandle = {
    getChecked: () => boolean,
}

/**
 * This is just a special class of IconButton, where the icons are either checked and unchecked,
 * with a label.  No internal state here.
 */
const CheckboxWithState = forwardRef<CheckboxWithStateHandle, CheckboxWithStateProps>((props, ref) => {
    const [checked, setChecked] = useState<boolean>(props.checked);

    const onClick = (e: MouseEvent) => {
        setChecked(prev => !prev);
        props.onClick(e, props.data);
    };

    useImperativeHandle(ref, () => {
        return {
            getChecked: () => checked,
        }
    }, [checked]);

    const classes = `Checkbox ${props.override ? 'Checkbox--override' : ''}`;

    return (
        // Just a checkbox and a label
        <div className={classes}>
            {/* CheckboxWithState */}

            <IconButton id={`Checkbox-${props.label}`}
                        autoFocus={props.autoFocus}
                        type={checked ? Icons.CHECKED : props.indeterminate ? Icons.INDETERMINATE : Icons.UNCHECKED}
                        onClick={onClick}
                        label={props.label}
                        disabled={props.disabled}
            />
        </div>
    )
});

CheckboxWithState.displayName = 'CheckboxWithState';

export type CheckboxWithStateProps = {
    autoFocus?: boolean,
    checked: boolean,
    indeterminate?: boolean,
    label?: ReactNode,
    onClick: (e: MouseEvent, data: any) => void,
    disabled?: boolean,
    data?: any,
    override?: boolean
};

export default CheckboxWithState;
